require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-institution-african-development-bank.json") })
        }
      }, "path---en-us-institution-african-development-bank");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-institution-african-development-bank!./.cache/json/en-us-institution-african-development-bank.json
// module id = 479
// module chunks = 231608221292675